function deletePlayer(fetch_cmd, customCallback) {
  fetch(fetch_cmd, {
    method: "POST",
    credentials: "include",
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      customCallback();
    });
}

export default deletePlayer;
